<template>
  <div>
    <v-container pt-0>
      <v-layout>
        <v-flex sm6 xs12 pt-5 pr-5>
          <h1>Resources for <span class="secondary--text">K-8 Math Educators</span></h1>
          <p class="bgray--text">Access easy-to-use, interactive, and time-saving resources to help you and your students in your math classrooms!</p>
        </v-flex>
        <v-flex sm6 hidden-sm-and-down>
          <img src="@/assets/resources-hero.png" style="margin: auto; margin-right: 0; height: 240px; display: block;" alt="Happy student after using Brainingcamp's digital math manipulatives.">
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl>
      <v-layout wrap fill-height justify-center text-xs-center text-md-left>
        <v-flex lg3 md6 sm6 xs10 v-if="!isClassroom">
          <div class="resource_card">
            <div class="card_thumb">
              <img src="@/assets/resources-webinars.png" alt="Teacher participating in Brainingcamp webinar">
            </div>
            <div class="card_body">
              <h2>Webinars</h2>
              <p>High-quality PD from leading math experts. Discover upcoming live sessions or watch recordings on demand.</p>
              <v-btn
                color="gold"
                href="https://www.brainingcamp.com/webinars"
                target="_blank"
              >
                WATCH
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex lg3 md6 sm6 xs10>
          <div class="resource_card">
            <div class="card_thumb">
              <img src="@/assets/resources-tasks.png" alt="Pre-made math tasks for teachers - Brainingcamp">
            </div>
            <div class="card_body">
              <h2>Tasks</h2>
              <p>Access 300 high-quality K-8 Tasks, complete with Teacher Notes and Share Codes for students to launch.</p>
              <v-btn
                color="gold"
                href="https://www.brainingcamp.com/tasks"
                target="_blank"
              >
                EXPLORE
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex lg3 md6 sm6 xs10>
          <div class="resource_card">
            <div class="card_thumb">
              <img src="@/assets/resources-tutorials.png" alt="Teacher exploring Brainingcamp's math tutorial.">
            </div>
            <div class="card_body">
              <h2>Tutorials</h2>
              <p>Short videos to get you and your students started with Brainingcamp Virtual Math Manipulatives.</p>
              <v-btn
                color="gold"
                href="https://www.brainingcamp.com/tutorials"
                target="_blank"
              >
                LEARN
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex lg3 md6 sm6 xs10>
          <div class="resource_card">
            <div class="card_thumb">
              <img src="@/assets/resources-blog.png" alt="Teacher exploring Brainingcamp's math tutorial.">
            </div>
            <div class="card_body">
              <h2>Blog</h2>
              <p>A diverse range of perspectives and ideas on mathematics education to help you enhance the student learning experience.</p>
              <v-btn
                color="gold"
                href="https://www.brainingcamp.com/blog"
                target="_blank"
              >
                READ
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

  export default {
    components: {
    },
    computed: {
      isLoggedIn: function () {
        return this.$store.getters.loggedIn;
      },
      isClassroom: function () {
        if (this.$store.getters.user) {
          return this.$store.getters.user.type === 'classroom';
        }
        return false;
      },
      isH2M: function () {
        if (this.$store.getters.vendor === 'hand2mind') {
          return true;
        }

        return false;
      },
      iosVisitor: function () {
        if (this.$route.query.referrer === 'ios'){
          return true;
        }

        return false;
      }
    }
  }
</script>

<style scoped>
.decoration_container {
  position: relative;
}

.decoration_container .decoration {
  position: absolute;
}

.resource_card .card_thumb {
  background: #EBF5FE;
  border: #BCC5CD 2px solid;
  border-bottom: 0;
  border-radius: 200px 200px 0 0;
  padding: 0 32px;
}

.resource_card .card_thumb img {
  margin: auto auto 0 auto;
  width: 100%;
  display: block;
}

.resource_card .card_body {
  padding: 16px 4px;
  background: white;
  border: #BCC5CD 2px solid;
  border-top: 0px;
  border-radius: 0 0 16px 16px;
  height: 256px;
}

.resource_card h2 {
  padding: 0 16px;
  color: #072846;
  font-size: 24px;
}

.resource_card p {
  padding: 0 16px;
  color: #39536B;
  height: 120px;
}
</style>
